module.exports = __webpack_public_path__ + "static_pc/img/ba14.057b589e.jpg";